import { useEffect, useRef } from "react";
import { useWebgate } from "@xvia/webgate-connect";
/**
 * O token é credencial, não gatilho: como dependência de efeito ele refaz a
 * carga a cada renovação do portal. O ref entrega o valor atual na hora da
 * chamada e `hasAccessToken` só muda quando a sessão começa ou termina.
 */
export var useAccessTokenRef = function () {
    var accessToken = useWebgate().accessToken;
    var accessTokenRef = useRef(accessToken);
    useEffect(function () {
        accessTokenRef.current = accessToken;
    }, [accessToken]);
    return { accessTokenRef: accessTokenRef, hasAccessToken: !!accessToken };
};
